<br>
<h1 class="titulo">Catálogos</h1>

<div class="select-container">
  <nz-select 
    class="large-select" 
    nzPlaceHolder="Selecciona una opción"
    [(ngModel)]="selectedOption"
    (ngModelChange)="onSelectChange($event)">
    <nz-option nzValue="umas" nzLabel="UMAS"></nz-option>
    <nz-option nzValue="calendario-pago" nzLabel="Calendario de Pago"></nz-option>
    <nz-option nzValue="sat" nzLabel="Pre-Fijos SAT"></nz-option>
  </nz-select>
</div>
<br>
<br>

<nz-spin [nzSpinning]="loading" nzTip="Cargando..." class="loading-spinner">
<div class="tabla-principal">

      <div class="tabla-header-container">
    <div class="tabla-header-left">
      <span class="registros-label"
        >Registros: <strong>{{ tableData.length }}</strong></span
      >
    </div>
    <div class="tabla-header-right">
      <button 
        nz-button 
        nzType="primary" 
        class="excel-button"
        (click)="agregarCampo()"
        *ngIf="selectedOption != 'umas'"
        >
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        Agregar Campo
      </button>
    </div>
  </div>

    <div class="table-scroll-container">
      <nz-table
      #basicTable
      [nzData]="tableData || []"
      class="tabla-colaboradores tabla-compacta"
      [nzShowPagination]="true"
    >
    <thead>
      <tr>
        <th *ngIf="selectedOption !== 'sat'" class="col-acciones">Acciones</th>
        <th *ngFor="let header of tableHeaders" [class]="'col'">
          {{ header.title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of basicTable.data">
        <!-- Fila principal -->
        <tr>
        <td *ngIf="selectedOption !== 'sat'" class="col-acciones">
          <div class="center-container" *ngIf=" selectedOption != 'umas'; else TemplateUMASActions">
            <img
              src="assets/icon/edit.svg"
              class="icono-sgmm"
              style="cursor: pointer;"
              alt="icono sgmm"
              (click)="abrirDrawerEdicion(item)"
            />
            <img
              *ngIf="selectedOption !== 'sat'"
              src="assets/icon/trash.svg"
              class="icono-sgmm"
              style="cursor: pointer;"
              alt="icono sgmm"
              nz-popconfirm
              nzPopconfirmTitle="¿Estás seguro de eliminar este registro?"
              nzPopconfirmPlacement="top"
              (nzOnConfirm)="eliminarRegistro(item)"
            />
          </div>
          <ng-template #TemplateUMASActions>
             <div class="center-container">
                <img
                  src="assets/icon/edit.svg"
                  class="icono-sgmm"
                  style="cursor: pointer;"
                  alt="icono sgmm"
                  *ngIf="getPeridosAjustes(item.anio); else TemplateNoActionsUMA"
                  (click)="abrirDrawerEdicion(item)"
                />
                <ng-template #TemplateNoActionsUMA>
                    <!-- <img
                      src="assets/icon/edit-disabled.svg"
                      class="icono-sgmm-disabled"
                      style="cursor: not-allowed;"
                      [nz-tooltip]="'No se pueden editar UMAS con fechas pasadas'"
                      alt="icono sgmm"
                    /> -->
                    <!-- <i nz-icon nzType="right" class="breadcrumb-separator"></i> -->
                    <span nz-icon nzType="more" nzTheme="outline" [nz-tooltip]="'No se pueden editar UMAS con fechas pasadas'">
                    </span>
                  </ng-template>
                </div>
              </ng-template>
        </td>
        
        <ng-container [ngSwitch]="selectedOption">         
          <!-- Campos para UMAS -->
          <ng-container *ngSwitchCase="'umas'">
            <!-- Fecha de Inicio -->
            <td>
              <div class="celda">
                {{ item.fechaInicio | date:'dd/MM/yyyy' }}
              </div>
            </td>
            
            <!-- Fecha de Fin -->
            <td>
              <div class="celda">
                {{ item.fechaFin | date:'dd/MM/yyyy' }}
              </div>
            </td>

            <td>
              <div class="celda">
                {{ item.anio }}
              </div>
            </td>
            
            <!-- UMA -->
            <td>
              <div class="celda">
                {{ item.valorUma | currency:'MX$':'symbol':'1.2-2' }}
              </div>
            </td>
          </ng-container>
          
          <!-- Campos para Calendario de Pago -->
          <ng-container *ngSwitchCase="'calendario-pago'">
            <!-- Mes Contable -->
            <td>
              <div class="celda">
                {{ item.mesContable }}
              </div>
            </td>
            
            <!-- Periodo Inicio -->
            <td>
              <div class="celda">
                {{ item.periodoInicio | date:'dd/MM/yyyy' }}
              </div>
            </td>
            
            <!-- Periodo Fin -->
            <td>
              <div class="celda">
                {{ item.periodoFin | date:'dd/MM/yyyy' }}
              </div>
            </td>
            
            <!-- Límite Info Colaborador -->
            <td>
              <div class="celda">
                {{ item.limiteInfoColaborador | date:'dd/MM/yyyy HH:mm' }}
              </div>
            </td>
            
            <!-- Límite Info SAP -->
            <td>
              <div class="celda">
                {{ item.limiteInfoSap | date:'dd/MM/yyyy HH:mm' }}
              </div>
            </td>
          </ng-container>
          
          <!-- Campos para Catálogo SAT -->
          <ng-container *ngSwitchCase="'sat'">
            <!-- Descripción -->
            <td>
              <div class="celda">
                {{ item.descripcion || 'Sin descripción' }}
              </div>
            </td>
            
            <!-- Código Inicio Clase -->
            <td>
              <div class="celda">
                {{ item.codigoInicioClase || '-' }}
              </div>
            </td>
            
            <!-- Código Fin Clase -->
            <td>
              <div class="celda">
                {{ item.codigoFinClase || '-' }}
              </div>
            </td>
            
            <!-- Categoría -->
            <td>
              <div class="celda">
                <nz-tag [nzColor]="getCategoryColor(item.categoria)">
                  {{ item.categoria }}
                </nz-tag>
              </div>
            </td>
            
            <!-- Estado Válido -->
            <td>
              <div class="celda">
                <nz-tag [nzColor]="item.esValido ? 'green' : 'red'">
                  {{ item.esValido ? 'Válido' : 'Inválido' }}
                </nz-tag>
              </div>
            </td>
            
            <!-- Botón Ver Códigos Clase -->
            <td>
              <div class="celda">
                <button 
                  *ngIf="item.codigosClase && item.codigosClase.length > 0"
                  nz-button 
                  nzType="link" 
                  nzSize="small"
                  (click)="toggleCodigosClase(item.id)"
                  class="ver-codigos-btn">
                  <i nz-icon [nzType]="isCodigosExpanded(item.id) ? 'up' : 'down'"></i>
                  Ver códigos ({{ item.codigosClase.length }})
                </button>
                <span *ngIf="!item.codigosClase || item.codigosClase.length === 0" class="no-codigos">
                  Sin códigos
                </span>
              </div>
            </td>
          </ng-container>
          
        </ng-container>
      </tr>
      
      <tr *ngIf="selectedOption === 'sat' && isCodigosExpanded(item.id)" class="codigos-expandidos">
        <td colspan="6" class="codigos-detalle">
          <div class="codigos-container">
            <!-- Tabla de códigos -->
            <div class="table-vertical-scroll">
              <nz-table 
                [nzData]="item.codigosClase || []" 
                [nzShowPagination]="false"
                nzSize="small"
                class="codigos-table">
              <thead>
                <tr>
                  <th>Acciones</th>
                  <th>Tipo</th>
                  <th>Descripción</th>
                  <th>Código Exacto</th>
                  <th>Código Inicio</th>
                  <th>Código Fin</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let codigo of item.codigosClase; let codigoIndex = index">
                  <!-- Acciones -->
                  <td>
                    <div class="acciones-codigos">
                      <img
                        src="assets/icon/edit.svg"
                        class="icono-sgmm"
                        style="cursor: pointer;"
                        alt="icono sgmm"
                        (click)="abrirDrawerEdicion({ clase: item, codigo: codigo })"
                      />
                      <img
                        src="assets/icon/trash.svg"
                        class="icono-sgmm"
                        style="cursor: pointer;"
                        alt="icono sgmm"
                        nz-popconfirm
                        nzPopconfirmTitle="¿Estás seguro de eliminar este código?"
                        nzPopconfirmPlacement="top"
                        (nzOnConfirm)="eliminarCodigo(item, codigo)"
                      />
                    </div>
                  </td>
                  
                  <!-- Tipo Concepto -->
                  <td>
                    <div class="celda">
                      <nz-tag [nzColor]="codigo.tipoConcepto === 'EXACTO' ? 'blue' : 'orange'">
                        {{ codigo.tipoConcepto }}
                      </nz-tag>
                    </div>
                  </td>
                  
                  <!-- Descripción -->
                  <td>
                    <div class="celda">
                      {{ codigo.descripcion }}
                    </div>
                  </td>
                  
                  <!-- Código Exacto -->
                  <td>
                    <div class="celda">
                      {{ codigo.codigoExacto || '-' }}
                    </div>
                  </td>
                  
                  <!-- Código Inicio -->
                  <td>
                    <div class="celda">
                      {{ codigo.codigoInicio || '-' }}
                    </div>
                  </td>
                  
                  <!-- Código Fin -->
                  <td>
                    <div class="celda">
                      {{ codigo.codigoFin || '-' }}
                    </div>
                  </td>
                  
                  <!-- Estado -->
                  <td>
                    <div class="celda">
                      <nz-tag [nzColor]="codigo.esValido ? 'green' : 'red'" nzSize="small">
                        {{ codigo.esValido ? 'Válido' : 'Inválido' }}
                      </nz-tag>
                    </div>
                  </td>
                </tr>
              </tbody>
            </nz-table>
            </div>
          </div>
        </td>
      </tr>
      </ng-container>
    </tbody>
    </nz-table>
  </div>
</div>
</nz-spin>



